'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

exports.isSpreadLoopContainer = isSpreadLoopContainer;
exports.transformJSXComprehension = transformJSXComprehension;
exports.maybeTransformJSXExpressionWithSpreadLoop = maybeTransformJSXExpressionWithSpreadLoop;
exports.maybeTransformObjectWithSpreadLoops = maybeTransformObjectWithSpreadLoops;
exports.maybeTransformArrayWithSpreadLoops = maybeTransformArrayWithSpreadLoops;

var _types = require('../types');

var _types2 = _interopRequireDefault(_types);

var _tails = require('../helpers/tails');

var _blocks = require('../helpers/blocks');

var _astLocUtils = require('ast-loc-utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function isSpreadLoopContainer(node) {
  return ((0, _types.isa)(node, "SpreadElement") || (0, _types.isa)(node, "SpreadProperty")) && (0, _types.isa)(node.argument, "SpreadLoop");
} // prevent generated spreadexpr from being further transformed
function safe(node) {
  node._safe = true;
  return node;
}function validateComprehensionBody(path) {
  return path.traverse({
    noScope: true,

    Function(path) {
      path.skip();
    }, AwaitExpression(awaitPath) {
      throw awaitPath.buildCodeFrameError("`await` is not allowed within Comprehensions; " + "instead, await the Comprehension.");
    }, YieldExpression(yieldPath) {
      throw yieldPath.buildCodeFrameError("`yield` is not allowed within Comprehensions.");
    }, ReturnStatement(returnPath) {
      throw returnPath.buildCodeFrameError("`return` is not allowed within Comprehensions.");
    } });
}function iife(body, id, initializer) {
  var loc = (0, _astLocUtils.getSurroundingLoc)(body);

  body.unshift((0, _astLocUtils.placeAtNode)(_types2.default.variableDeclaration("const", [(0, _astLocUtils.placeAtNode)(_types2.default.variableDeclarator(id, initializer), id)]), id));
  body.push((0, _astLocUtils.placeAtLoc)(_types2.default.returnStatement(id), (0, _astLocUtils.span)(loc, -1)));

  return (0, _astLocUtils.placeAtLoc)(_types2.default.callExpression((0, _astLocUtils.placeAtLoc)(_types2.default.arrowFunctionExpression([], (0, _astLocUtils.placeAtLoc)(_types2.default.blockStatement(body), loc)), loc), []), loc);
}function isSimpleObject(objExpr) {
  var _objExpr$properties, _objExpr$properties$;

  return ((_objExpr$properties = objExpr.properties) == null ? void 0 : _objExpr$properties.length) === 1 && objExpr.properties[0].type === "ObjectProperty" && !((_objExpr$properties$ = objExpr.properties[0].decorators) == null ? void 0 : _objExpr$properties$.length);
}function isSimpleArray(arrExpr) {
  var _arrExpr$elements;

  return ((_arrExpr$elements = arrExpr.elements) == null ? void 0 : _arrExpr$elements.length) === 1 && arrExpr.elements[0].type !== "SpreadElement";
}function transformJSXComprehensionTails(loopPath, ref) {
  var bodyPath = loopPath.get("body");
  validateComprehensionBody(bodyPath);
  var foundOne = false;
  (0, _tails.transformTails)(bodyPath, true, false, function (expr) {
    foundOne = true;
    return (0, _astLocUtils.placeAtNode)(_types2.default.callExpression((0, _astLocUtils.placeAtNode)(_types2.default.memberExpression(ref, (0, _astLocUtils.placeAtNode)(_types2.default.identifier("push"), expr)), expr), [expr]), expr);
  });

  if (!foundOne) {
    throw loopPath.buildCodeFrameError("Spread loops must end with an expression.");
  }
}function transformJSXComprehension(exprPath) {
  var node = exprPath.node;

  var loopPath = exprPath.get("loop");
  var ref = (0, _astLocUtils.placeAtLoc)(_types2.default.clone(exprPath.scope.generateUidIdentifier("arr")), (0, _astLocUtils.span)((0, _astLocUtils.getLoc)(node), 1));
  var initializer = (0, _astLocUtils.placeAtLoc)(_types2.default.arrayExpression(), (0, _astLocUtils.span)((0, _astLocUtils.getLoc)(node), 1));
  transformJSXComprehensionTails(loopPath, ref);
  exprPath.replaceWith(iife([loopPath.node], ref, initializer));
}function maybeTransformJSXExpressionWithSpreadLoop(path) {
  if ((0, _types.isa)(path.node.expression, "SpreadLoop")) {
    transformJSXComprehension(path.get("expression"));
    return true;
  } else {
    return false;
  }
}function transformObjectComprehensionTails(loopPath, id) {
  var bodyPath = loopPath.get("body");
  validateComprehensionBody(bodyPath);
  var foundOne = false;
  (0, _tails.transformTails)(bodyPath, true, false, function (expr) {
    foundOne = true;

    if (isSimpleObject(expr)) {
      // Simple object case: { [k]: v } --> obj[k] = v
      var _expr$properties = _slicedToArray(expr.properties, 1),
          prop = _expr$properties[0];

      return (0, _astLocUtils.placeAtNode)(_types2.default.assignmentExpression("=", (0, _astLocUtils.placeAtNode)(_types2.default.memberExpression(id, prop.key, prop.computed || !(0, _types.isa)(prop.key, "Identifier")), expr), prop.value), expr);
    } else {
      // Complex object case: { ... } -> Object.assign(obj, { ... })
      return (0, _astLocUtils.placeAtNode)(_types2.default.callExpression((0, _astLocUtils.placeTreeAtLocWhenUnplaced)(_types2.default.memberExpression(_types2.default.identifier("Object"), _types2.default.identifier("assign")), (0, _astLocUtils.getLoc)(expr)), [id, expr]), expr);
    }
  });

  if (!foundOne) {
    throw bodyPath.buildCodeFrameError("Spread loops must end with an expression.");
  }
}function transformObjectWithSpreadLoops(path, spreadLoopPaths, plainProps) {
  var node = path.node;

  var ref = (0, _astLocUtils.placeAtLoc)(_types2.default.clone(path.scope.generateUidIdentifier("obj")), (0, _astLocUtils.span)((0, _astLocUtils.getLoc)(node), 1));
  path.replaceWith(iife(function () {
    var _arr = [];for (var _i3 = 0, _len4 = spreadLoopPaths.length; _i3 < _len4; _i3++) {
      var _p = spreadLoopPaths[_i3];
      transformObjectComprehensionTails(_p, ref);
      _arr.push(_p.node);
    }return _arr;
  }(), ref, (0, _astLocUtils.placeAtLoc)(_types2.default.objectExpression(plainProps), (0, _astLocUtils.getSurroundingLoc)(plainProps))));
  undefined;
}function maybeTransformObjectWithSpreadLoops(path) {
  var node = path.node;
  var properties = node.properties;


  var plainProps = [];var spreadLoopPaths = [];
  for (var _i4 = 0, _len5 = properties.length; _i4 < _len5; _i4++) {
    var _p2 = properties[_i4];
    if (isSpreadLoopContainer(_p2)) {
      spreadLoopPaths.push(path.get(`properties.${_i4}.argument.loop`));
    } else {
      plainProps.push(_p2);
    }
  }if (spreadLoopPaths.length === 0) return false;

  transformObjectWithSpreadLoops(path, spreadLoopPaths, plainProps);
  return true;
}function transformArrayComprehensionTails(loopPath, ref) {
  var bodyPath = loopPath.get("body");
  validateComprehensionBody(bodyPath);
  var foundOne = false;
  (0, _tails.transformTails)(bodyPath, true, false, function (expr) {
    foundOne = true;
    return (0, _astLocUtils.placeAtNode)(_types2.default.callExpression((0, _astLocUtils.placeAtNode)(_types2.default.memberExpression(ref, (0, _astLocUtils.placeAtNode)(_types2.default.identifier("push"), expr)), expr), isSimpleArray(expr) ? [expr.elements[0]] : [safe((0, _astLocUtils.placeAtNode)(_types2.default.spreadElement(expr), expr))]), expr);
  });

  if (!foundOne) {
    throw loopPath.buildCodeFrameError("Spread loops must end with an expression.");
  }
}function pushBundle(stmts, ref, bundle) {
  if (!bundle.length) return;
  var loc = (0, _astLocUtils.getSurroundingLoc)(bundle);
  // _ref.push(bundle...)
  return stmts.push((0, _blocks.toStatement)((0, _astLocUtils.placeAtLoc)(_types2.default.callExpression((0, _astLocUtils.placeAtLoc)(_types2.default.memberExpression(ref, (0, _astLocUtils.placeAtLoc)(_types2.default.identifier("push"), loc)), loc), bundle), loc)));
}function transformArrayWithSpreadLoops(path) {
  var node = path.node;
  var elements = node.elements;

  var ref = (0, _astLocUtils.placeAtLoc)(_types2.default.clone(path.scope.generateUidIdentifier("arr")), (0, _astLocUtils.span)((0, _astLocUtils.getLoc)(node), 1));

  var i = 0,
      len = elements.length,
      stmts = [],
      bundle = [],
      first = true,
      initializer = void 0;
  while (i < len) {
    var element = elements[i];
    if (isSpreadLoopContainer(element)) {
      if (first) {
        initializer = bundle;
        first = false;
      } else {
        pushBundle(stmts, ref, bundle);
      }bundle = [];
      var loopPath = path.get(`elements.${i}.argument.loop`);
      transformArrayComprehensionTails(loopPath, ref);
      stmts.push(loopPath.node);
    } else {
      bundle.push(element);
    }i++;
  }pushBundle(stmts, ref, bundle);

  return path.replaceWith(iife(stmts, ref, (0, _astLocUtils.placeAtLoc)(_types2.default.arrayExpression(initializer), (0, _astLocUtils.getSurroundingLoc)(initializer))));
}function maybeTransformArrayWithSpreadLoops(path) {
  var node = path.node;
  var elements = node.elements;

  for (var _i5 = 0, _len6 = elements.length; _i5 < _len6; _i5++) {
    var _e = elements[_i5];
    if (isSpreadLoopContainer(_e)) {
      transformArrayWithSpreadLoops(path);
      return true;
    }
  }return false;
}